import { defaultSearchDate } from '../../lib/dates';
import { slugify } from '../../lib/geo';
import { useUserLocation } from '../../state/location';

/** Link (to + router state) to a search around the visitor, or New York. */
export function useNearbySearchLink() {
  const { effective } = useUserLocation();
  const place = effective.name || 'Near me';
  return {
    to: `/hotels/${effective.cc || 'us'}/${slugify(place)}?date=${defaultSearchDate()}`,
    state: { lat: effective.lat, lng: effective.lng, geoname: place },
  };
}
